import React, { Component } from "react";
import { Form, Button, Input, Checkbox, Row, Col, Spin, Select } from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import VehicleGroupStore from "../store/VehicleGroupStore";
import SensorMappingStore from "../store/SensorMappingStore";
import withRouter from "../withRouter";
import CompanyAutocomplete from "./CompanyAutocomplete";
import CompanyStore from "../store/CompanyStore";


class SensorMappingAdd extends Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      selectedChecked: false,
      selectedValues: [],
      sensorMappingId: -1,
      companyId: "",
      loadingSpin: false,
      vehicleSearchArray: [],
      savedSelectedValues: [],
      sensor_data: [],
      sensor_mapping: [],
      selectedMappings: {},
    };
    this.sensorMappingStore = new SensorMappingStore();
    this.groupStore = new VehicleGroupStore();
    this.companyStore = new CompanyStore();
  }
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {

      this.context.viewStateStore.setVehicleGroupStates({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
        isadmin: this.props.getUserData().isadmin,
      });
      const data = await this.groupStore.getAssetData(
        {
          companyId: this.props.getUserData().userCompanyId,
          isadmin: this.props.getUserData().isadmin,
          userId: this.props.getUserData().userId,
        }
      );
      await this.setState({ vehicleSearchArray: data });
    }

    const sensorMappingId = this.props.sensorMappingId;
    if (sensorMappingId) {
      await this.filldata(sensorMappingId);
      await this.setState({ sensorMappingId });
    }

    const { sensor_data, sensor_mapping } = await this.sensorMappingStore.sensorCodecData();

    this.setState({ sensor_data, sensor_mapping });
    
  }

  filldata = async (sensorMappingId) => {

    await this.setState({ loadingSpin: true });

    const sensorMappingData = await this.sensorMappingStore.loadData({
      companyId: this.props.companyId,
      offset: 0,
      limit: 1,
      sensorMappingId: sensorMappingId
   });

    const allVehicles = await this.groupStore.getAssetData({
      companyId: this.props.companyId,
    });

    await this.setState({ vehicleSearchArray: allVehicles });


    const singleData = await this.companyStore.getCompanyDataById(
      this.props.companyId
    );

    await this.setState({
      companyId: sensorMappingData?.data?.companyId,
      sensorMappingId: sensorMappingData?.data[0]?.id,
    });

    let vehicleData = [];
    sensorMappingData?.vehicleIds?.forEach((val) => {
      vehicleData.push(val.vehicleId);
    });

    if (vehicleData.length === allVehicles.length) {
      this.setState({ selectedChecked: true });
    }

    const selectedMappings = {};

    sensorMappingData?.sensorMappings?.forEach((item) => {
      selectedMappings[item.sensorId] = item.mappingId;
    });

    await this.setState({
      selectedValues: vehicleData,
      savedSelectedValues: vehicleData,
      selectedMappings: selectedMappings
    });

    await this.formRef.current.setFieldsValue({
      companyId: singleData,
      templateName: sensorMappingData?.data[0]?.templateName
    });

    await this.setState({ loadingSpin: false });
  };

  onSensorMappingSubmit = async (values) => {

    this.setState({ loading: true });

    const data = {
      templateId: this.state.sensorMappingId,
      companyId: this.state.companyId,
      templateName: values.templateName,
      vehicleIds: this.state.selectedValues,
      createdBy: this.props.getUserData().userId,
      updatedBy: this.props.getUserData().userId,
      sensors: Object.entries(this.state.selectedMappings).map(
        ([sensorId, mappingId]) => ({
          sensorId: Number(sensorId),
          mappingId,
        })
      ),
    };

    // console.log("Submit Data =>", data);

    const resp = await this.sensorMappingStore.addData(data);

    await this.setState({
      savedSelectedValues: this.state.selectedValues,
    });

    await this.props.response(resp);

    this.setState({ loading: false });

  };

  // CHANGE: Converted handleChange from regular async method to arrow function
  // — prevents losing `this` context when called from JSX onChange
  handleChange = async (comp) => {
    await this.setState({ companyId: comp.value });
    if (!this.props.vehicleGroupId) {
      this.context.viewStateStore.setVehicleGroupStates({
        companyId: comp.value,
      });
    }
    // await this.formRef.current.setFieldsValue({ companyId: comp.value });

    const data = await this.groupStore.getAssetData({
      companyId: comp.value,
      isadmin: this.props.getUserData().isadmin,
      userId: this.props.getUserData().userId,
    });
    this.setState({ vehicleSearchArray: data });
    // CHANGE: Removed broken handleSearch() call — used undefined currentPage/pageSize state
  };

  handleMappingChange = (sensorId, mappingId) => {
    this.setState((prev) => ({
      selectedMappings: {
        ...prev.selectedMappings,
        [sensorId]: mappingId,
      },
    }));
  };

  handleSelectAllChange = async (e) => {
    const checked = e.target.checked;
    this.setState({ selectedChecked: checked });

    if (checked) {
      const allValues = this.groupStore?.assetList.map(
        (option) => option.vehicleId
      );
      await this.setState({ selectedValues: allValues });
    } else {
      await this.setState({ selectedValues: [] });
    }
  };

  handleSingleCheckboxChange = async (e, vehicleId) => {
    const { checked } = e.target;
    let selectedValues = [...this.state.selectedValues];

    if (checked) {
      if (!selectedValues.includes(vehicleId)) {
        selectedValues.push(vehicleId);
      }
    } else {
      selectedValues = selectedValues.filter((id) => id !== vehicleId);
    }

    await this.setState({
      selectedValues,
      selectedChecked:
        selectedValues.length === this.groupStore.assetList.length,
    });
  };

  searchVehicles = async (searchValue) => {
    const lowerSearch = searchValue.toLowerCase();
    await this.groupStore.getAssetData({
      companyId: this.state.companyId,
      isadmin: this.props.getUserData().isadmin,
      userId: this.props.getUserData().userId,
      search: lowerSearch,
    });
    return this.groupStore?.assetList?.filter(
      (vehicle) =>
        vehicle.vehicleNo &&
        vehicle.vehicleNo.toLowerCase().includes(lowerSearch)
    );
  };

  // CHANGE: Extracted vehicle search inline onChange into a named arrow method
  handleVehicleSearch = async (e) => {
    const searchValue = e.target.value;
    if (!searchValue) {
      await this.groupStore.getAssetData({
        companyId: this.state.companyId,
        isadmin: this.props.getUserData().isadmin,
        userId: this.props.getUserData().userId,
      });
      this.setState({ vehicleSearchArray: this.groupStore.assetList });
      return;
    }
    const searchedArray = await this.searchVehicles(searchValue);
    this.setState({
      vehicleSearchArray:
        searchedArray?.length === 0 ? this.groupStore.assetList : searchedArray,
    });
  };

  closeModal = () => {
    this.props.closeModal();
  };

  render() {
    const {
      selectedChecked,
      selectedValues,
      savedSelectedValues,
      vehicleSearchArray,
      loadingSpin,
      loading,
    } = this.state;

    return (
      <div style={{ padding: 0, height: "100%" }}>
        <Spin spinning={loadingSpin} wrapperClassName="spinClass" fullscreen>
          <Form
            layout="vertical"
            ref={this.formRef}
            onFinish={this.onSensorMappingSubmit }
            name="nest-message"
            className="formClass"
          >
            <div
            className="overflowFormInputs"
              style={{
                padding: "16px",
                marginBottom: "16px",
              }}
            >
              <Row gutter={16}>
                {(this.props.getUserData().isadmin === -1 ||
                  this.props.getUserData().isadmin === 3) && (
                    <Col span={12}>
                      <Form.Item
                        name="companyId"
                        label={
                          <span>
                            {this.context.translate("_ACCOUNT_")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        required={false}
                        rules={[
                          {
                            required: true,
                            message: `${this.context.translate("_ACCOUNT_")} ${this.context.translate("_IS_REQUIRED_")}`,
                          },
                        ]}
                      >
                        <CompanyAutocomplete
                          value={this.state.companyId}
                          onChange={this.handleChange}
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                  )}

                  <Col span={12}>
                    <Form.Item
                      name="templateName"
                      label={
                        <span>
                          {this.context.translate("_TEMPLATE_NAME_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate("_TEMPLATE_NAME_")} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>

                  {this.state.sensor_data.map((sensor) => (
                    <Col span={12} key={sensor.id}>
                      <Form.Item
                        label={`${sensor.name} (${sensor.id})`}
                      >
                        <Select
                          allowClear
                          placeholder="Select Mapping"
                          value={this.state.selectedMappings[sensor.id]}
                          onChange={(value) =>
                            this.handleMappingChange(sensor.id, value)
                          }
                        >
                          {this.state.sensor_mapping.map((mapping) => {
                            const selectedValues = Object.values(
                              this.state.selectedMappings
                            );

                            const disabled =
                              selectedValues.includes(mapping.id) &&
                              this.state.selectedMappings[sensor.id] !== mapping.id;

                            return (
                              <Select.Option
                                key={mapping.id}
                                value={mapping.id}
                                disabled={disabled}
                              >
                                {mapping.name}
                              </Select.Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                    </Col>
                  ))}

                <Col span={24}>
                  <div
                    style={{
                      marginTop: "10px",
                      border: "1px solid #d9d9d9",
                      borderRadius: "6px",
                      padding: "16px",
                      marginBottom: "16px",
                      marginRight: "18px",
                      marginLeft: "15px"
                    }}
                  >
                    <Row gutter={8} align="middle">
                      <Col span={10}>
                        <Input
                          size="small"
                          placeholder={
                            this.context.translate("_SEARCH_VEHICLES_") ||
                            "Search Vehicles"
                          }
                          onChange={this.handleVehicleSearch}
                          allowClear
                          style={{ fontSize: "12px" }}
                        />
                      </Col>
      
                      <Col span={4} style={{ textAlign: "center" }}>
                        <span style={{ fontSize: "12px", fontWeight: 500 }}>
                          Selected: {this.state.selectedValues?.length || 0}
                        </span>
                      </Col>
      
                      <Col
                        span={10}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        <span style={{ fontSize: "12px", whiteSpace: "nowrap" }}>
                          {this.context.translate("_FLEET_GROUP_GROUPDETAIL_SELECTVEHICLE_")}
                        </span>
      
                        <Checkbox
                          checked={selectedChecked}
                          onChange={this.handleSelectAllChange}
                          style={{ fontSize: "12px" }}
                        >
                          {this.context.translate("_ALL_")}
                        </Checkbox>
                      </Col>
                    </Row>

                    <div style={{ fontSize: "11px", color: "#aaa", marginBottom: "8px" }}>
                      {this.context.translate("_SELECT_ALL_NOTE_")}
                    </div>
                    {vehicleSearchArray?.length > 0 && (
                      <div
                        style={{
                          border: "1px solid #f0f0f0",
                          borderRadius: "4px",
                          padding: "10px",
                          height: "260px",
                          overflowY: "auto",
                        }}
                      >
                        <Row gutter={[8, 8]}>
                          
                          {vehicleSearchArray
                            ?.slice()
                            .sort((a, b) => {
                              const aSelected = savedSelectedValues.includes(a.vehicleId);
                              const bSelected = savedSelectedValues.includes(b.vehicleId);
                              if (aSelected && !bSelected) return -1;
                              if (!aSelected && bSelected) return 1;
                              return 0;
                            })
                            .map((value) => (
                              <Col span={8} key={value.vehicleId}>
                                <Checkbox
                                  checked={selectedValues.includes(value.vehicleId)}
                                  onChange={(e) =>
                                    this.handleSingleCheckboxChange(e, value.vehicleId)
                                  }
                                >
                                  {value.vehicleNo}
                                </Checkbox>
                              </Col>
                            ))}
                        </Row>
                      </div>
                    )}      
                  </div>
                </Col>

              </Row>
            </div>


            {/* Footer */}
            <div className="formFooter">
              <Button
                className="formsCancelButton"
                onClick={() => {
                  this.closeModal();
                  this.setState({ selectedChecked: false, selectedValues: [] });
                }}
              >
                {this.context.translate("_FLEET_DASHBORD_ROUTEADD_CANCELBTN_")}
              </Button>
              <Button
                htmlType="submit"
                className="formsSaveButton"
                loading={loading}
              >
                {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
              </Button>
            </div>
          </Form>
        </Spin>
      </div>
    );

  }
}

SensorMappingAdd.contextType = StoreContext;
export default observer(withRouter(SensorMappingAdd));